// cogido de one_frontend v1.3.3 (981ffb251c50b28600119c681405dccc4f2f112f)
// https://marmelab.com/react-admin/Translation.html

import polyglotI18nProvider from "ra-i18n-polyglot";
import glCustomMessages from "./gl-messages";
import esCustomMessages from "./es-messages";
import euCustomMessages from "./eu-messages";
import esDefaultReactAdminMessages from "./es-default-react-admin-messages";
import glDefaultReactAdminMessages from "./gl-default-react-admin-messages";
import euDefaultReactAdminMessages from "./eu-default-react-admin-messages";
const merge = require("deepmerge");

const removeEmpty = (obj) => {
  Object.keys(obj).forEach(
      (k) =>
          (obj[k] && typeof obj[k] === "object" && removeEmpty(obj[k])) ||
          (!obj[k] && obj[k] !== undefined && delete obj[k])
  );
  return obj;
};

const esMessages = merge(esDefaultReactAdminMessages, esCustomMessages);

const glMessages = merge(
    esCustomMessages,
    merge(glDefaultReactAdminMessages, removeEmpty(glCustomMessages))
);

const euMessages = merge(
    esCustomMessages,
    merge(euDefaultReactAdminMessages, removeEmpty(euCustomMessages))
);

const i18nProvider = polyglotI18nProvider((locale) => {
  switch (locale) {
    case "gl":
      return glMessages;

    case "es":
      return esMessages;

    case "eu":
      return euMessages;

    default:
      return esMessages;
  }
}, "es");

export { i18nProvider };